import { useQuery } from '@tanstack/react-query';
import { useAsyncExcelExport } from 'features/asyncExport';
import { isListEnabled } from 'utils/queryHelpers';

import { QueryContextFromKeys, QueryParamModel } from 'models';
import { statisticsService } from 'services';

type DocumentLogQueryContexts = QueryContextFromKeys<typeof documentLogKeys>;

export const documentLogKeys = {
  all: [{ scope: 'documentLog' }] as const,
  lists: () => [{ ...documentLogKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) => [{ ...documentLogKeys.lists()[0], params }] as const,
  export: (params?: QueryParamModel | null) => [{ ...documentLogKeys.lists()[0], params }] as const,
};

const fetchDocumentLogList = async ({ queryKey: [{ params }] }: DocumentLogQueryContexts['list']) =>
  statisticsService.getDocumentLogList(params);

const exportDocumentLog = async ({ queryKey: [{ params }] }: DocumentLogQueryContexts['list']) =>
  statisticsService.exportDocumentLog(params);

const exportDocumentLogAsyncExcel = async ({
  queryKey: [{ params }],
}: DocumentLogQueryContexts['export']) => statisticsService.exportDocumentLogAsyncExcel(params);

export const useDocumentLogList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: documentLogKeys.list(params),
    queryFn: fetchDocumentLogList,
    enabled: isListEnabled(params),
  });
};

export const useExportDocumentLog = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: documentLogKeys.list(params),
    queryFn: exportDocumentLog,
    enabled: false,
  });
};

export const useDocumentLogAsyncExcelExport = (params?: QueryParamModel | null) => {
  return useAsyncExcelExport(documentLogKeys.export(params), exportDocumentLogAsyncExcel);
};
